export default {
    reset_password_title: "Restablecer contraseña",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    repeat_new_password: "Repetir nueva contraseña",
    save: "Guardar",
    fill_all_fields: "Por favor, complete todos los campos",
    passwords_dont_match: "Las contraseñas no coinciden",
    wrong_password: "La contraseña proporcionada es incorrecta",
    password_changed_success: "Contraseña actualizada con éxito.",
    page_title: "Kevi | Restablecer contraseña",
    two_factor: {
        title: "Autenticación 2FA",
        setup_title: "Configurar Autenticación de 2 Factores",
        scan_instruction:
            "Escanea el código QR con tu aplicación de autenticación para continuar con los siguientes pasos",
        scanned_button: "Ya lo escaneé",
        enter_code_title: "Ingrese el código de verificación",
        verify_code_placeholder: "Código de verificación",
        validate_button: "Validar Código",
        backup_codes_title: "Tus códigos de respaldo",
        backup_important_message:
            "Estos códigos son importantes y no volverán a aparecer. Anótalos en un lugar seguro en caso de que pierdas tu dispositivo.",
        copy_instruction:
            'Haz clic en "Copiar Códigos" para copiar todos los códigos a la vez y poder regresar.',
        copy_codes_button: "Copiar Códigos",
        back_button: "Volver",
        copy_success: "¡Códigos copiados con éxito!",
        invalid_code: "¡Código inválido!",
        error_qr: "Error al generar el código QR",
        error_backup: "Error al generar códigos de respaldo",
    },
    rewards: {
        title: "Kevi Fideliza",
        points: "puntos",
        points_label: "Puntos",
        use_now: "Utilizar ahora",
        support_contact: "Para utilizar contacte con soporte",
        missing: "Faltan",
        missing_one: "Falta 1 punto",
        page_title: "Mis puntos",
        confirm_redeem: "¿Estás seguro de que quieres canjear tu premio?",
        redeem_success: "¡Premio canjeado con éxito!",
    },
};
